import Vue from 'vue'

Vue.prototype.stringTime = function (now) {
    var year = now.getFullYear()
    var month = now.getMonth() + 1
    var day = now.getDate()
    var h = now.getHours()
    var m = now.getMinutes()
    var s = now.getSeconds()
    month = month < 10 ? '0' + month : month
    day = day < 10 ? '0' + day : day
    h = h < 10 ? '0' + h : h
    m = m < 10 ? '0' + m : m
    s = s < 10 ? '0' + s : s
    var str = year + '-' + month + '-' + day + ' ' + h + ':' + m + ':' + s
    return str
}

Vue.prototype.requestData = function (data) {
    var sign = dataForm(data)
    sign = md5(sign).toUpperCase()
    data.sign = sign
    var str = dataForm(data)
    return str
}

Vue.prototype.isNull = function(data) {
   return (data == "" || data == undefined || data == null) ? true : false;
}

Vue.prototype.getBeforeDate = function(n, type) {
    const d = new Date()
    let year = d.getFullYear()
    let mon = d.getMonth() + 1
    let day = d.getDate()
    const hours = d.getHours()
    const minutes = d.getMinutes()
    const seconds = d.getSeconds()
    if (day <= n) {
      if (mon > 1) {
        mon = mon - 1
      } else {
        year = year - 1
        mon = 12
      }
    }
    d.setDate(d.getDate() - n)
    year = d.getFullYear()
    mon = d.getMonth() + 1
    day = d.getDate()
    if (type === 'date') {
      const s = year + '-' + (mon < 10 ? ('0' + mon) : mon) + '-' + (day < 10 ? ('0' + day) : day)
      return s
    } else {
      const s = year + '-' + (mon < 10 ? ('0' + mon) : mon) + '-' + (day < 10 ? ('0' + day) : day) + ' ' + (hours < 10 ? ('0' + hours) : hours) + ':' + (minutes < 10 ? ('0' + minutes) : minutes) + ':' + (seconds < 10 ? ('0' + seconds) : seconds)
      return s
    }
}

// 获取两个日期相差天数 sDate1和sDate2是yyyy-mm-dd格式
Vue.prototype.dateDiff = function (sDate1, sDate2) {
  const startDate = Date.parse(sDate1)
  const endDate = Date.parse(sDate2)
  if (startDate > endDate) { return 0 }
  if (startDate === endDate) { return 1 }
  var days = (endDate - startDate) / (1 * 24 * 60 * 60 * 1000)
  return days
}

// 复制文本
Vue.prototype.copyBtn = function(txt) {
  const save = function(e) {
    e.clipboardData.setData('text/plain',txt)
    e.preventDefault() //阻止默认行为
  }
  document.addEventListener('copy',save)  // 添加一个copy事件
  document.execCommand('copy') // 执行copy方法
  this.$message({message:'复制成功',type: 'success'})
}